<template>
  <div class="textAlign-c width-90 paddingLr90 height">
    <template>
      <el-carousel :interval="8000" ref="carousel" arrow="always">
        <el-carousel-item class="flex-row justify-content-start align-items-center">
          <van-image :src="indexImg" fit="cover" class="" />
        </el-carousel-item>
        <el-carousel-item v-for="(item, index) in imgList" :key="index" class="flex-row justify-content-start align-items-center">
          <van-image @click="jump(urlList[index])" :src="item" fit="cover" class="" />
        </el-carousel-item>
      </el-carousel>
    </template>
  </div>
</template>
<script>
import profileApi from '@/api/profileApi';
import config from '@/config';

export default {
  name: 'page1',
  components: {},
  data() {
    return {
      indexImg: require('@/assets/image/page1_06.jpg'),
      imgList: [],
      urlList: []
    };
  },
  created() {},
  mounted() {
    profileApi
      .one({ profileCode: 'index_swiper' })
      .then((res) => {
        res.data.profileImgs.split(',').forEach((item) => {
          this.imgList.push(config.IMAGE_PREFIX + item);
        });
        res.data.profileContent.split(',').forEach((item) => {
          this.urlList.push(item);
        });
        this.$refs.carousel.handleMouseEnter = () => {};
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    jump(url) {
      window.open(url, '_blank');
    },
    delHandleMouseEnter() {
      this.$refs.carousel.handleMouseEnter = () => {};
    }
  }
};
</script>

<style lang="less" scoped>
.height {
  height: 940px;
}
/deep/.el-carousel--horizontal {
  height: 940px;
}
</style>
<style>
.el-carousel__container {
  max-height: 900px;
  height: 940px;
  width: 100%;
  /*max-width: 1920px;*/
  /*min-width: 1200px;*/
  margin: auto;
}
</style>
